import * as React from "react";
import './instanceLayoutBreadcrumb.css'

interface Props {
    steps: any,
    navigateToInstance: any
}

const InstanceLayoutBreadcrumb = (props: Props) => {

    const buildBreadcrumb = () => {
        if (props.steps.length > 1) {
            return props.steps.map((step, index) => {
                return <li key={index} title={getRelationshipsForTooltip(step ,index)} className={'bd-step'} onClick={() => props.navigateToInstance(step)}>
                    <div><p>{`${step.instanceName} (${step.boName})`}</p></div>
                </li>
            });
        }
    }

    const getRelationshipsForTooltip = (step: any, index: number): string => {
        let tooltipText = '';
        if (index >= 1) {
            if (step.relation) {
                if (step.relation.toBoClassInfo.outward) {
                    tooltipText += `${step.instanceName} ${step.relation.outward} ${props.steps[index - 1].instanceName }.` + '\n';
                } else {
                    tooltipText += `${step.instanceName} ${step.relation.inward} ${props.steps[index - 1].instanceName}.` + '\n';
                }
            }
        }
        return tooltipText;
    }

    return (
        <div id={'crumbs'} className={'bd-wrapper'}>
            <ul className={'bd-container'}>
                {buildBreadcrumb()}
            </ul>
        </div>
    )
}
export default InstanceLayoutBreadcrumb;



// WEBPACK FOOTER //
// ./app/components/bo-core/instanceLayoutEditor/breadcrumbComponent/InstanceLayoutBreadcrumb.tsx